import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RouterService } from '@shared/services/router.service';
import { ModalService } from '@core/services';

@Component({
  standalone: false,
  selector: 'hm-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
})
export class ErrorPageComponent implements OnInit {
  protected statusCode!: string | null;
  protected errorCode!: string | null;
  protected title = '';
  protected description = '';
  protected buttonLabel!: string;

  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly routerService = inject(RouterService);
  private readonly modalService = inject(ModalService);

  ngOnInit(): void {
    this.modalService.closeAll();

    this.statusCode = this.route.snapshot.queryParamMap.get('statusCode');
    this.errorCode = this.route.snapshot.queryParamMap.get('errorCode');

    switch (this.statusCode) {
      case '403':
        return this.create403ErrorPage();
      case '404':
        return this.create404ErrorPage();
      default:
        return this.createSomethingWentWrongErrorPage();
    }
  }

  navigateBack() {
    // Navigate to offices for specific error codes
    if (
      this.errorCode === 'EntityNotFound' ||
      this.errorCode === 'BuildingNotFound' ||
      this.errorCode === 'BuildingsNotFound'
    ) {
      return this.router.navigate(['/admin/manage-mappings/offices']);
    }

    const { previousUrl } = this.routerService.getUrlsState();

    if (previousUrl) {
      return this.router.navigateByUrl(previousUrl);
    }

    return this.router.navigate(['..']);
  }

  private create403ErrorPage() {
    this.title = 'Access denied';
    this.description = 'You do not have access to this page.';
    this.buttonLabel = '';
  }

  private create404ErrorPage() {
    this.title = 'Page not found';
    this.description =
      'We can’t find the page you are looking for. You can either return to the previous page or homepage.';
    this.buttonLabel = 'Go to Homepage';
  }

  private createSomethingWentWrongErrorPage() {
    this.description = 'Something went wrong';
    this.buttonLabel = 'Reload page';
  }
}
